import { useState, useCallback, useEffect } from "react";
import axios from "../../axios";
// import {useEffectOnce} from 'react-use';


const useEffectOnce = (effect, controller) => {
  const memoizedEffect = useCallback(effect, [controller]);

  useEffect(() => {
    memoizedEffect();
  }, [memoizedEffect]);
};


export function useAddServiceArea(){
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null)

  const { loadData }= useGetALLServiceArea()
  
  async function mutate(payload, cb){
    try{
      setLoading(true)
      const {data } = await axios.post('/api/service_area/add', payload);
      setLoading(false)
      setResponse(data);
      loadData();
      cb({ success:true, message:`Zone ${payload?.id?"updated":"added"} successfull` })
    }catch(err){
     setLoading(false);
     cb({ success: false, message:err?.message })
    }
  }

  return {
    mutate,
    loading,
    response
  }

}


// get All service Area
export function useGetALLServiceArea(){
  const [loading, setLoading] = useState(false);
  const [areas, setAreas] = useState([]);
  const [controller, setController] = useState(null);


  async function loadData(){
   try{
    setLoading(true)
    const { data } = await axios.get('/api/service_area/list');
    setAreas(data)
    setLoading(false)


   }catch(err){
    setLoading(false)
   }
  }

  useEffectOnce(() => {
    loadData()

    return () => {
      // 
    }
  }, controller);

  return {
    loading,
    areas,
    setController,
    loadData
  }

}